import { Arrow, Down, Shield } from "../icons";
import { Credentials } from "../layout";

export function Referrals() {
  return (
    <section className="wrap-m section">
      <h1 className="center">Referrals</h1>
      <p className="center soft" style={{ maxWidth: 640, margin: "0 auto 3rem" }}>WarmNest Counselling welcomes referrals from healthcare professionals, social workers, organisations and employers. Where a client's needs fall outside the scope of wellness counselling, we refer onward to an appropriate practitioner with the client's written consent.</p>
      <div className="cards-2">
        <article className="tile peach" style={{ textAlign: "left", display: "flex", flexDirection: "column" }}>
          <span className="kicker" style={{ textAlign: "left" }}>Form WC-REF-IN-01</span>
          <h2 style={{ fontSize: "1.5rem" }}>Incoming Referral</h2>
          <p className="soft" style={{ fontSize: "0.875rem", flex: 1 }}>Referring a client <strong>to</strong> WarmNest Counselling. For professionals and organisations.</p>
          <p style={{ display: "flex", gap: "0.75rem", flexWrap: "wrap" }}>
            <a className="btn btn-dark" href="/wwc-incoming-referral-form.pdf" download><Down size={16} /> Download PDF</a>
            <a className="btn btn-line" href="/referrals/incoming">Details <Arrow /></a>
          </p>
        </article>
        <article className="tile sage" style={{ textAlign: "left", display: "flex", flexDirection: "column" }}>
          <span className="kicker" style={{ textAlign: "left" }}>Form WC-REF-OUT-01</span>
          <h2 style={{ fontSize: "1.5rem" }}>Outgoing Referral</h2>
          <p className="soft" style={{ fontSize: "0.875rem", flex: 1 }}>Referring a client <strong>to another professional</strong>. Completed by the counsellor with signed client consent.</p>
          <p style={{ display: "flex", gap: "0.75rem", flexWrap: "wrap" }}>
            <a className="btn btn-dark" href="/wwc-outgoing-referral-form.pdf" download><Down size={16} /> Download PDF</a>
            <a className="btn btn-line" href="/referrals/outgoing">Details <Arrow /></a>
          </p>
        </article>
      </div>
      <div className="callout lavender" style={{ margin: "2.5rem 0" }}>
        <Shield />
        <p>All referral information is treated as strictly confidential in accordance with POPIA (Act 4 of 2013). Completed forms may be emailed to <a className="link" href="mailto:warmnestcounselling@gmail.com">warmnestcounselling@gmail.com</a> or sent via WhatsApp to <a className="link" href="tel:+27814727220">081 472 7220</a>.</p>
      </div>
      <Credentials />
    </section>
  );
}
